import { Component, AfterViewInit, EventEmitter, Output } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { UsuarioService } from '../../services/usuario.service';
import { ParametroService } from '../../services/parametro.service';
import { Cliente, MDC, Usuario, Parametro, Cuenta } from '../../interfaces/beans.interface';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UsuarioMDCService } from '../../services/usuario.mdc.service';
import { CuentaService } from '../../services/cuenta.service';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { VistaService } from 'src/app/services/vista.service';
declare var $: any;

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html'
})
export class NavigationComponent implements AfterViewInit {
  @Output() toggleSidebar = new EventEmitter<void>();

  public config: PerfectScrollbarConfigInterface = {};
  public showSearch = false;
  usuario: Usuario = <Usuario>{};
  clientes: Cliente[] = [];
  mdcs: MDC[] = [];
  idCliente: string;
  idMDC: string;
  mostrarCabecera: boolean = false;
  licencia: Parametro = <Parametro>{};
  imageUrl: any;
  cuenta: Cuenta;

  menus: string[];
  permisos: string[];

  constructor(private vistaService: VistaService, private titleService: Title, private sanitizer: DomSanitizer, private cuentaService: CuentaService, private parametroService: ParametroService, private usuarioService: UsuarioService, private usuarioMDCService: UsuarioMDCService, private toastr: ToastrService, private router: Router) {
    this.titleService.setTitle('net.Home');
    this.licencia.valor = 'NO';
    this.loadCuenta();
    this.obtenerClientes();
  }

  // This is for Notifications
  notifications: Object[] = [
    {
      btn: 'btn-danger',
      icon: 'ti-link',
      title: 'Luanch Admin',
      subject: 'Just see the my new admin!',
      time: '9:30 AM'
    },
    {
      btn: 'btn-success',
      icon: 'ti-calendar',
      title: 'Event today',
      subject: 'Just a reminder that you have event',
      time: '9:10 AM'
    },
    {
      btn: 'btn-info',
      icon: 'ti-settings',
      title: 'Settings',
      subject: 'You can customize this template as you want',
      time: '9:08 AM'
    },
    {
      btn: 'btn-primary',
      icon: 'ti-user',
      title: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  // This is for Mymessages
  mymessages: Object[] = [
    {
      useravatar: 'assets/images/users/1.jpg',
      status: 'online',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:30 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'busy',
      from: 'Sonu Nigam',
      subject: 'I have sung a song! See you at',
      time: '9:10 AM'
    },
    {
      useravatar: 'assets/images/users/2.jpg',
      status: 'away',
      from: 'Arijit Sinh',
      subject: 'I am a singer!',
      time: '9:08 AM'
    },
    {
      useravatar: 'assets/images/users/4.jpg',
      status: 'offline',
      from: 'Pavan kumar',
      subject: 'Just see the my admin!',
      time: '9:00 AM'
    }
  ];

  ngAfterViewInit() {}

  loadCuenta() {
    this.cuentaService.get().subscribe(
      message => {
        if (message['httpStatus'] === 200) {
          this.cuenta = message['cuenta'];
          let fileBlob = this.base64ToArrayBuffer(this.cuenta.imagenDatos);
          let blob = new Blob([fileBlob], { type: 'image/jpg' });
          let imageToShow = URL.createObjectURL(blob);
          this.imageUrl = this.sanitizer.bypassSecurityTrustUrl(imageToShow);
        }
      },
      error => {
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener los clientes asignados al usuario');
        } else if (error.status === 403) {
          this.goLogin();
        }
      }
    );
  }

  obtenerClientes() {
    let idUsuario = localStorage.getItem('idUsuario');
    this.usuarioService.getByUsername(idUsuario).subscribe(
      messageClientes => {
        if (messageClientes['httpStatus'] === 200) {
          this.usuario = messageClientes['usuario'];
          let user = messageClientes['usuario'];
          this.clientes = user.clientes;
          localStorage.setItem('idCliente', this.clientes[0].id);
          this.idCliente = this.clientes[0].id;
          this.getLicencia();
        }
      },
      error => {
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener los clientes asignados al usuario');
        } else if (error.status === 403) {
          this.goLogin();
        }
      }
    );
  }

  changeCliente() {
    localStorage.setItem('idCliente', this.idCliente);
    this.getLicencia();
  }

  obtenerMDCs() {
    if (this.licencia.valor !== 'NO') {
      this.mdcs = [];
      let idUsuario = localStorage.getItem('idUsuario');
      this.usuarioMDCService.getAll(idUsuario).subscribe(
        messageMDCs => {
          if (messageMDCs['httpStatus'] === 200) {
            let usuariosMDC = messageMDCs['usuariosMDC'];
            if (usuariosMDC.length > 0) {
              for (let usuarioMDC of usuariosMDC) {
                this.mdcs.push(usuarioMDC.mdc);
              }
              localStorage.setItem('idMdc', this.mdcs[0].id);
              this.idMDC = this.mdcs[0].id;
              localStorage.removeItem('sinLicencia');

              /* Obtenemos permisos */ 
              this.vistaService.get().subscribe(
                message => {
                    if (message['httpStatus'] === 200) {
                        this.menus = message['menus'];
                        this.permisos = message['permisos'];
                        let menusAux = '';
                        let permisosAux = '';

                        for(let i=0; i<this.menus.length; i++){
                          menusAux = menusAux + this.menus[i] + '#';
                        }
                        for(let i=0; i<this.permisos.length; i++){
                          permisosAux = permisosAux + this.permisos[i] + '#';
                        }

                        localStorage.setItem('menus', menusAux);
                        localStorage.setItem('permisos', permisosAux);
                        this.router.navigate(['dashboard/pedidos']);
                    }
                }
              );              
            } else {
              this.mostrarCabecera = true;
            }
          }
        },
        error => {
          if (error.status === 0) {
            this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener los MDCs asignados al usuario');
          } else if (error.status === 403) {
            this.goLogin();
          }
        }
      );
    } else {
      let mdc: MDC = <MDC>{};
      mdc.id = '-1';
      mdc.ubicacion = 'SIN LICENCIA';
      this.mdcs = [];
      this.mdcs.push(mdc);
      this.idMDC = this.mdcs[0].id;
      localStorage.setItem('idMdc', this.idMDC);
      localStorage.setItem('sinLicencia', '1');
      //this.router.navigate(['dashboard/pedidos']);
      this.router.navigate(['noPermiso/noproveedor']);
      this.showMessage('warning', 'Sin licencia activa', 'El proveedor no tiene licencia activa, es necesario renovarla');
    }
  }

  changeMDC() {
    if (this.idMDC !== '-1') {
      localStorage.setItem('idMdc', this.idMDC);
      this.vistaService.get().subscribe(
        message => {
            if (message['httpStatus'] === 200) {
                this.menus = message['menus'];
                this.permisos = message['permisos'];
                let menusAux = '';
                let permisosAux = '';

                for(let i=0; i<this.menus.length; i++){
                  menusAux = menusAux + this.menus[i] + '#';
                }
                for(let i=0; i<this.permisos.length; i++){
                  permisosAux = permisosAux + this.permisos[i] + '#';
                }

                localStorage.setItem('menus', menusAux);
                localStorage.setItem('permisos', permisosAux);
                this.router.navigate(['dashboard/pedidos']);
            }
        }
      ); 
    }
  }

  getLicencia() {
    localStorage.setItem('LicenciaActiva', 'NO');
    this.parametroService.getLicencia().subscribe(
      message => {
        if (message['httpStatus'] === 200) {
          this.licencia = message['parametro'];
          if (this.licencia.valor === 'NO') {
            localStorage.setItem('LicenciaActiva', this.licencia.nombre);
          } else {
            localStorage.setItem('LicenciaActiva', 'SI');
          }
          this.obtenerMDCs();
        }
      },
      error => {
        if (error.status === 0) {
          this.showMessage('error', 'Error de conexión', 'No existe conexión para obtener los clientes asignados al usuario');
        } else if (error.status === 403) {
          this.goLogin();
        }
      }
    );
  }

  base64ToArrayBuffer(base64: any): any {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
       let ascii = binaryString.charCodeAt(i);
       bytes[i] = ascii;
    }
    return bytes;
 }

 createImageFromBlob(image: Blob) {
  let reader = new FileReader();
  reader.addEventListener('load', () => {
     this.imageUrl = reader.result;
  }, false);

  if (image) {
     reader.readAsDataURL(image);
  }
}

  goProfile(){
    this.router.navigate(['cuenta/profile']);
  }

  goEventos(){
    this.router.navigate(['cuenta/eventos']);
  }

  showMessage(tipo: string, titulo: string, descripcion: string) {
    switch (tipo) {
      case 'success':
        this.toastr.success(descripcion, titulo);
        break;
      case 'error':
        this.toastr.error(descripcion, titulo);
        break;
      case 'warning':
        this.toastr.warning(descripcion, titulo);
        break;
      case 'info':
        this.toastr.info(descripcion, titulo);
        break;
    }
  }

  goLogin() {
    localStorage.clear();
    this.router.navigate(['']);
  }
}
